// [BD Feat] Js for the accordion, video play, pause

document.addEventListener("DOMContentLoaded", function () {
  // Accordion functionality
  const headers = document.querySelectorAll(".accordion-item-header");
  if (headers.length) {
    headers.forEach(header => {
      header.addEventListener("click", () => {
        header.classList.toggle("active");

        const body = header.nextElementSibling;
        if (body) {
          if (header.classList.contains("active")) {
            body.style.maxHeight = body.scrollHeight + "px";
          } else {
            body.style.maxHeight = 0;
          }
        }
      });
    });
  }

  // Video controls
  let isPlaying = false;
  const video = document.querySelector('.video-wrapper .video');
  const controlButton = document.querySelector('.video-control-button');
  const videoContent = document.querySelector('.video-content');

  function showVideo() {
    if (video) video.style.display = 'block';
  }

  function toggleVideoPlayback() {
    if (!video || !controlButton) return;

    controlButton.classList.add('hide-focus');

    if (!isPlaying) {
      showVideo();
      video.play();
      controlButton.classList.add('hide-button');
      controlButton.setAttribute('aria-label', 'Pause Video');
      isPlaying = true;
    } else {
      video.pause();
      controlButton.classList.remove('hide-button');
      controlButton.setAttribute('aria-label', 'Play Video');
      isPlaying = false;
    }
  }

  if (controlButton) {
    controlButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      toggleVideoPlayback();
    });

    controlButton.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        event.stopPropagation();
        toggleVideoPlayback();
      }
    });
  }

  if (video) {
    video.addEventListener('click', function () {
      if (isPlaying) {
        video.pause();
        if (controlButton) {
          controlButton.classList.remove('hide-button');
          controlButton.setAttribute('aria-label', 'Play Video');
        }
        isPlaying = false;
      } else {
        video.play();
        if (controlButton) {
          controlButton.classList.add('hide-button');
          controlButton.setAttribute('aria-label', 'Pause Video');
        }
        isPlaying = true;
      }
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Tab' && event.shiftKey && isPlaying) {
      if (videoContent) {
        event.preventDefault();
        video.pause();
        if (controlButton) {
          controlButton.classList.remove('hide-button');
          controlButton.setAttribute('aria-label', 'Play Video');
        }
        videoContent.setAttribute('tabindex', '0');
        videoContent.focus();
        isPlaying = false;
      }
    }
  });

  if (videoContent) {
    videoContent.addEventListener('blur', function () {
      videoContent.setAttribute('tabindex', '-1');
    });
  }

  // Modal
  const nutritionTrigger = document.querySelector('.open-newsletter-modal');
  const modalCloseButtons = document.querySelectorAll('.story__modal-close');

  if (nutritionTrigger) {
    nutritionTrigger.addEventListener('click', () => {
      const modal = document.getElementById('Modal-faq');
      if (modal) {
        document.body.classList.add('story__modal--opened');
        modal.classList.add('open');
      }
    });
  }

  if (modalCloseButtons.length) {
    modalCloseButtons.forEach((closeButton) => {
      closeButton.addEventListener('click', () => {
        document.body.classList.remove('story__modal--opened');
        const openModal = document.querySelector('.story__modal.open');
        if (openModal) {
          openModal.classList.remove('open');
        }
      });
    });
  }
});
